import { uid } from "@xbs/lib-state";
import moveColumn from "./move";
export default function (store, ev) {
    const id = ev.id || ev.column?.id || uid();
    const state = store.getState();
    const columns = state.columns;
    const colObj = {
        id,
        label: "Untitled",
        ...(ev.column || {}),
    };
    columns.push(colObj);
    const { cardsMap, areasMeta } = store.getInnerState({
        ...state,
        columns,
    });
    store.setState({ columns, cardsMap, areasMeta });
    if (ev.before) {
        moveColumn(store, { ...ev, id });
    }
    store.in.exec("scroll", {
        to: "column",
        id,
    });
    ev.id = id;
    ev.column = colObj;
    return () => {
        store.in.exec("delete-column", { id, $meta: { skipHistory: true } });
    };
}
//# sourceMappingURL=add.js.map